import { render } from "./App.vue?vue&type=template&id=55873ef4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=55873ef4&lang=scss"

import exportComponent from "/opt/jenkins/data/workspace/PRD.standard_checktarget_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__